import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, switchMap } from 'rxjs';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { UserRole } from '../../enums/users/role';
import { BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfied } from '../../models/block-navigation-if-preferred-payment-method-requirement-unsatisfied';
import { BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage } from './constants/block-navigation-if-preferred-payment-method-requirement-unsatisfied-message';

@Injectable({
    providedIn: 'root',
})
export class BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedGuard {
    private readonly dialog = inject(MatDialog);
    private readonly userStateService = inject(UserStateService);

    canDeactivate(
        component: BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfied,
    ): Observable<boolean> {
        const role = this.userStateService.getRole();
        if (role !== UserRole.Customer) {
            return of(true);
        }

        if (!component.isPreferredPaymentMethodRequirementSatisfied) {
            const dialogRef = this.dialog.open(ModalComponent, {
                disableClose: true,
                data: {
                    title: BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage.modalTitle,
                    content:
                        BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage.modalContent,
                    primaryAction: {
                        title: BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage
                            .primaryAction.title,
                        name: BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage
                            .primaryAction.name,
                        action: () => dialogRef.close(true),
                    },
                    isShowCancel: true,
                },
            });

            return dialogRef.afterClosed().pipe(
                switchMap((result: boolean) => {
                    return of(result);
                }),
            );
        } else {
            return of(true);
        }
    }
}
